import { render } from "./header.vue?vue&type=template&id=40ab44d5&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=40ab44d5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-40ab44d5"

export default script